import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "lg:w-[35%] mdlg:w-[40%] h-auto bg-white rounded-md flex flex-col space-y-6 px-6 py-6 shadow-md" }
const _hoisted_2 = { class: "w-full flex flex-row items-center justify-center" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Reset Your Password ")
const _hoisted_4 = { class: "w-full flex flex-col space-y-4" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" New Password ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Confirm New Password ")
const _hoisted_7 = { class: "w-full flex flex-col pt-2" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Reset ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_roof_header_text = _resolveComponent("roof-header-text")!
  const _component_roof_text_field = _resolveComponent("roof-text-field")!
  const _component_roof_button = _resolveComponent("roof-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_roof_header_text, {
        size: 'xl',
        customClass: '!font-extrabold'
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_roof_text_field, {
        placeholder: 'Enter Password',
        "has-title": true,
        padding: 'px-3 py-4',
        customClass: 'bg-gray-100 !rounded-md',
        type: "password"
      }, {
        title: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }),
      _createVNode(_component_roof_text_field, {
        placeholder: 'Confirm Password',
        "has-title": true,
        padding: 'px-3 py-4',
        customClass: 'bg-gray-100 !rounded-md',
        type: "password"
      }, {
        title: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_roof_button, { padding: 'py-4' }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      })
    ])
  ]))
}